import React from 'react'

/**
 * The CardWrapper function is a React component that wraps a set of children components in a div
 * container with specific styling and layout properties.
 * @returns The CardWrapper component is returning a div element with the class name 'sm:full
 * md:mt-[3rem] mt-[4.25rem] md:h-full bg-[#F2F2F2]'. Inside this div, there is another div element
 * with the class name 'overflow-x-auto lg:grid grid-cols-4 gap-4  px-4 py-[0.
 */
function CardWrapper({ children, className }) {
    return (
        <div className='sm:full md:mt-[3rem] mt-[4.25rem] md:h-full bg-[#F2F2F2]'>
            <div className={`hidden md:block md:overflow-x-auto lg:grid lg:grid-cols-4 lg:gap-4 lg:px-4 lg:py-[0.7rem] lg:overflow-hidden ${className}`} style={{scrollbarWidth: 'none'}}>
                <div className="md:grid md:grid-cols-4 md:gap-4 md:px-4 md:min-w-max lg:contents">
                    {children}
                </div>
            </div>
            <div className='border-b-2 border-[#e5e5e5]'></div>
        </div >
    )
}

export default CardWrapper